import { Link } from 'react-router-dom';
import { TicketStatusBadge } from './TicketStatusBadge';
import type { PortalTicket } from '@/types';

interface TicketListProps {
  tickets: PortalTicket[];
}

function formatDate(dateStr: string): string {
  const date = new Date(dateStr);
  const now = new Date();
  const diffMs = now.getTime() - date.getTime();
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);

  if (diffMins < 1) return 'Just now';
  if (diffMins < 60) return `${diffMins}m ago`;
  if (diffHours < 24) return `${diffHours}h ago`;
  if (diffDays < 7) return `${diffDays}d ago`;
  return date.toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: date.getFullYear() !== now.getFullYear() ? 'numeric' : undefined });
}

export function TicketList({ tickets }: TicketListProps) {
  if (tickets.length === 0) {
    return (
      <div className="py-12 text-center text-muted-foreground">
        No requests found.
      </div>
    );
  }

  return (
    <div className="divide-y border rounded-lg bg-card">
      {tickets.map((ticket) => (
        <Link
          key={ticket.id}
          to={`/requests/${ticket.id}`}
          className="flex items-start gap-4 p-4 hover:bg-muted/50 transition-colors"
        >
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-2 mb-1">
              <span className="text-xs text-muted-foreground font-mono">#{ticket.id.replace('tkt_', '')}</span>
              <TicketStatusBadge statusCategory={ticket.status_category} />
            </div>
            <h3 className="text-sm font-medium text-foreground truncate">
              {ticket.subject}
            </h3>
            {ticket.last_message_text && (
              <p className="text-xs text-muted-foreground mt-1 truncate">
                {ticket.last_message_text}
              </p>
            )}
          </div>
          <div className="flex-shrink-0 text-right">
            <div className="text-xs text-muted-foreground">
              {formatDate(ticket.last_updated_at)}
            </div>
            {ticket.message_count > 0 && (
              <div className="text-xs text-muted-foreground mt-1">
                {ticket.message_count} {ticket.message_count === 1 ? 'message' : 'messages'}
              </div>
            )}
          </div>
        </Link>
      ))}
    </div>
  );
}
